import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  display: flex;
  margin: 10px;
  flex-direction: column;
  position: relative;

  ${mediaMinWidth.smallDesktop} {
    width: 940px;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin: 10px 20px 20px 20px;
    width: calc(100vw - 100px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin: 10px 10px 20px 10px;
  }

  ${mediaMaxWidth.phone} {
    margin: 10px;
  }
`;

export const Inner = styled.div`
  background-color: #d0d0d0;
  border-radius: 8px;
  padding: 15px 20px;
  flex-direction: column;

  ${mediaMaxWidth.tablet} {
    padding: 10px 10px 35px 10px;
  }
`;

export const Message = styled.div`
  color: #333;
  font-weight: 500;
  font-style: italic;
  font-size: 1.1em;
  word-break: break-word;
  padding: 30px 0;
  position: relative;

  ${mediaMaxWidth.tablet} {
    font-size: 1em;
    text-align: center;
  }
`;

export const OpenButton = styled.div`
  font-size: 1.2em;
  cursor: pointer;
  color: #333;
  margin: 0 10px;

  &:hover {
    color: #f2008c;
  }

  ${mediaMaxWidth.tablet} {
    position: absolute;
    right: 0;
    left: 0;
    text-align: center;
    bottom: -35px;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0px;
  bottom: -7px;
  font-size: 1.4em;
  cursor: pointer;

  &:hover {
    color: #f2008c;
  }

  ${mediaMaxWidth.tablet} {
    position: absolute;
    right: 0;
    left: 0;
    text-align: center;
    bottom: -30px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-direction: row;

  ${mediaMaxWidth.tablet} {
    flex-direction: column;
  }
`;

export const About = styled.div`
  display: flex;
  align-items: center;

  ${mediaMaxWidth.tablet} {
    justify-content: center;
    margin-bottom: 10px;
  }
`;

export const Avatar = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid #fff;

  ${mediaMaxWidth.tablet} {
    height: 30px;
    width: 30px;
  }
`;

export const Name = styled.div`
  color: #333;
  font-weight: 700;
  margin: 0 5px 0 10px;

  ${mediaMaxWidth.tablet} {
    margin: 0 5px 0 7.5px;
    font-size: 0.85em;
  }
`;

export const Agency = styled.div`
  color: #333;
  font-weight: 500;

  ${mediaMaxWidth.tablet} {
    font-size: 0.85em;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;

  a:first-child {
    margin-right: 10px;

    button {
      background: #a4a4a4;
      color: #fff;
      border: 1px solid #fff;

      &:hover {
        background-color: #838383;
      }
    }
  }

  ${mediaMaxWidth.tablet} {
    a {
      button {
        padding: 2px;
        font-size: 0.9em;
        min-width: 80px;
      }
    }
  }
`;
